export class Vector2 {
  constructor(
    public x = 0,
    public y = 0,
  ) {}

  static normalized(vector: Vector2): Vector2 {
    const length = Math.hypot(vector.x, vector.y);
    return length === 0 ? new Vector2() : new Vector2(vector.x / length, vector.y / length);
  }

  static scaled(vector: Vector2, amount: number): Vector2 {
    return new Vector2(vector.x * amount, vector.y * amount);
  }
}
